import { useIsMutating } from '@tanstack/react-query';

import { GPTWheelOfFortuneButton } from './components/GPTWheelButton';
import { LuckyCardButton } from './components/LuckyCardGameButton';
import { BirdGameButton } from './components/BirdGameButton';
import { VendingMachineButton } from './components/VendingMachineButton';
import { useAreAllGamesAvailable } from 'src/EXPERIMENTAL_LIB/gpt/games/hooks/useAreAllGamesAvailable';
import { Separator } from 'src/components/Separator/Separator';
import { useEffect } from 'react';
import { useDrawer } from 'src/hooks/useDrawer';
import { DailyBonusButton } from './components/DailyBonusButton';

export const GPTButtonsBlock = () => {
  const isAuthenticationInProgress = useIsMutating({ mutationKey: ['login-mutation'] });
  const {
    areAllGamesAvailable,
    dailyBonus,
    refetchAllGamesStatuses,
    cardGame,
    birdGame,
    wheelOfFortune,
    vendingMachine
  } = useAreAllGamesAvailable();
  const { isLeftDrawerOpen } = useDrawer();

  useEffect(() => {
    if (isLeftDrawerOpen) {
      refetchAllGamesStatuses();
    }
  }, [isLeftDrawerOpen]);

  if (isAuthenticationInProgress || !areAllGamesAvailable) return null;

  return (
    <>
      <div className="flex w-full flex-col items-center justify-center gap-1">
        {cardGame && <LuckyCardButton />}
        {birdGame && <BirdGameButton />}
        <div className="flex w-full items-center gap-1 justify-center">
          {wheelOfFortune && <GPTWheelOfFortuneButton />}
          {dailyBonus && <DailyBonusButton />}
        </div>
        {vendingMachine && <VendingMachineButton />}
      </div>
      <Separator width="w-[100%]" noMarginTop />
    </>
  );
};
